module.exports = "/img/_/_/_/assets/images/creeper/book/epic//1.jpg?d40f1725e547aa00cb8f67b7e2a9f7cd";